import { roundedRect } from '@bn-games/render-helpers';
import { TILE_CORNER_RADIUS } from '../utils/constants.js';
import { rectBounds, type TileRect } from './TileRenderer.js';
import type { RenderPalette } from './palette.js';

/**
 * Canvas-drawn keyboard focus ring. Drawn only when the canvas itself owns
 * keyboard focus (caller's responsibility). Uses `palette.bannerBorder` so
 * the visual language matches backgammon iter 3 / checkers iter 4.
 *
 * Hand tiles and arm-slot tiles use the rounded-rect outline path; the
 * action-bar variant uses a plain rect so it matches the bar's geometry.
 */
export function drawTileFocusRing(
  ctx: CanvasRenderingContext2D,
  rect: TileRect,
  palette: RenderPalette,
): void {
  const { x, y, width, height } = rectBounds(rect);
  ctx.save();
  ctx.strokeStyle = palette.bannerBorder;
  ctx.lineWidth = 3;
  ctx.setLineDash([5, 4]);
  roundedRect(ctx, x - 3, y - 3, width + 6, height + 6, TILE_CORNER_RADIUS + 3);
  ctx.stroke();
  ctx.restore();
}

export function drawActionFocusRing(
  ctx: CanvasRenderingContext2D,
  rect: { x: number; y: number; w: number; h: number },
  palette: RenderPalette,
): void {
  ctx.save();
  ctx.strokeStyle = palette.bannerBorder;
  ctx.lineWidth = 3;
  ctx.setLineDash([5, 4]);
  ctx.strokeRect(rect.x - 3, rect.y - 3, rect.w + 6, rect.h + 6);
  ctx.restore();
}

export function drawLeadFocusRing(
  ctx: CanvasRenderingContext2D,
  centre: { x: number; y: number },
  radius: number,
  palette: RenderPalette,
): void {
  ctx.save();
  ctx.strokeStyle = palette.bannerBorder;
  ctx.lineWidth = 3;
  ctx.setLineDash([5, 4]);
  ctx.beginPath();
  ctx.arc(centre.x, centre.y, radius, 0, Math.PI * 2);
  ctx.stroke();
  ctx.restore();
}
